var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handle-login container"},[_c('common-icon',{attrs:{"icon-name":"spinner-third","icon-style":"duotone","margin-right":""}}),_vm._v(" Handle login. Please wait. ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }